// extracted by mini-css-extract-plugin
export default {"bivi-sync__container":"styles_bivi-sync__container__CKYPE","title":"styles_title__+PzTR"};